import SpinnerView from "./Spinner.view";
function SpinnerContainer(props) {
    return <SpinnerView />;
}

export default SpinnerContainer;
